import React from 'react'
import Image from 'next/image'
import { getImageUrl } from 'utils/image'

import { IArtistShowcase } from '@/types'
import { MarkdownContent } from '../MarkdownContent'

export const ArtistShowcaseCard = ({
  title,
  subtitle,
  image,
  content,
}: Omit<IArtistShowcase, 'id'>) => {
  return (
    <div className='relative flex flex-col items-center justify-center gap-5 bg-cool-50 px-8 py-6 text-center xs:rounded-lg'>
      <div>
        <h3 className='font-display text-sm text-cool-800'>{title}</h3>
        <p>{subtitle}</p>
      </div>

      <div className='relative flex h-[142px] w-[142px] items-center overflow-hidden rounded-full'>
        <Image
          src={getImageUrl(image.data, 'medium')}
          alt={image.data.attributes.alternativeText || 'Release Image'}
          className='object-fill'
          fill={true}
          quality={75}
        />
      </div>

      <div>
        <MarkdownContent>{content}</MarkdownContent>
      </div>
    </div>
  )
}
